import { Component } from '@angular/core';
import { SecondaryPageComponent } from '../../secondary-page/secondary-page.component';

@Component({
  selector: 'app-accomodations',
  standalone: true,
  imports: [],
  templateUrl: './accomodations.component.html',
  styleUrl: './accomodations.component.scss'
})
export class AccomodationsComponent extends SecondaryPageComponent {

}
